var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'app-common/view/email-password'], function($, EmailPasswordFormView) {
  var EmailPasswordPage;
  return EmailPasswordPage = (function(_super) {

    __extends(EmailPasswordPage, _super);

    function EmailPasswordPage() {
      EmailPasswordPage.__super__.constructor.apply(this, arguments);
    }

    EmailPasswordPage.prototype.pageId = 'email-password';

    return EmailPasswordPage;

  })(EmailPasswordFormView);
});
